import { render, staticRenderFns } from "./Builddevice.vue?vue&type=template&id=6fceb1b8&scoped=true"
import script from "./Builddevice.vue?vue&type=script&lang=js"
export * from "./Builddevice.vue?vue&type=script&lang=js"
import style0 from "./Builddevice.vue?vue&type=style&index=0&id=6fceb1b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fceb1b8",
  null
  
)

export default component.exports